// extracted by mini-css-extract-plugin
export var code = "ShortCode-module--code--LLgYP";
export var copy = "ShortCode-module--copy--6-njQ";
export var root = "ShortCode-module--root--PR2B5";